/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SpecialPaymentCount = {
    One: 'One',
    Two: 'Two',
    ThreeOrMore: 'ThreeOrMore'
} as const;
export type SpecialPaymentCount = typeof SpecialPaymentCount[keyof typeof SpecialPaymentCount];


export function instanceOfSpecialPaymentCount(value: any): boolean {
    for (const key in SpecialPaymentCount) {
        if (Object.prototype.hasOwnProperty.call(SpecialPaymentCount, key)) {
            if (SpecialPaymentCount[key as keyof typeof SpecialPaymentCount] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SpecialPaymentCountFromJSON(json: any): SpecialPaymentCount {
    return SpecialPaymentCountFromJSONTyped(json, false);
}

export function SpecialPaymentCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialPaymentCount {
    return json as SpecialPaymentCount;
}

export function SpecialPaymentCountToJSON(value?: SpecialPaymentCount | null): any {
    return value as any;
}

export function SpecialPaymentCountToJSONTyped(value: any, ignoreDiscriminator: boolean): SpecialPaymentCount {
    return value as SpecialPaymentCount;
}

